/* MXDVS fly-to-icon: Circuit, version 13 (12.10.2026, work board card FLY). Loaded on every page by sections/mxdvs-wish-icon.liquid.
   Approved in the demo "Saved to icon: Circuit" version 13 (approved by Max 12.10.2026 11:52; desktop as version 11):
   1. Matrix decode: the product photo turns into ASCII (. : - = + * # % @) that flickers through the glyphs.
   2. The plus line (Roboto Mono Light, 11px, 10.5px apart, one plus on each corner) starts at a bottom corner of the photo
      and climbs its edge; each row of ASCII slides sideways into it, bottom rows first.
      Desktop: the bottom right corner. On the product page the line then runs between the path line
      (~/store.mxdvs.co/collections/...) and the product title. Phones, product page: from the bottom left corner a
      short step down, one row under the photo to the right of the page, then up into the icon (each column of ASCII
      drops into that row, left first). Phones, other photos (cards): the bottom left corner, climbing.
   3. From there the line finds its own way to the wishlist or cart icon: it never crosses text, buttons, icons or photos,
      keeps 3px away from them and prefers few corners. One blinking plus runs a step ahead.
   4. Snake, like the old Nokia game: a body of 14 plusses; the tail follows the head along the same path.
      When the head lands the icon's dot pings once (ring grows to 3.5x from 0.7 in 1100 ms) and the icon bumps,
      and the rest of the body runs into the icon.
   When it plays:
   - Wishlist: after a save is confirmed (the "mx:wishlist" event with saved true).
   - Cart: after Shopify accepts the add (cart/add answers 200) with the cart drawer closed. Nothing plays when the drawer
     is already open. The drawer opens straight after the effect has finished. The cart dot only shows for the ping.
   - Less motion asked by the device: only the dot ping.
   - If the header is hidden at that moment, it slides in for the effect.
   No other theme file is changed: this listens to the existing events and requests. One drawing layer, made on first use and
   removed after each play. Store photos are read again at 300px wide, so the page's own photos are never touched. */
(function () {
  if (window.__mxFly) return;
  window.__mxFly = true;

  var CFG = {
    duration: 1400, hold: 0.3, cell: 7, glyphs: '01アイウエオカキクケコｱｲｳ#$%&', trip: '+',
    plusWeight: 300, plusSize: 11, spacing: 10.5, margin: 3, turn: 6,
    desk: { mode: 'side', corner: 'right', lane: true }, phone: { mode: 'under', corner: 'left', lane: false }, phoneCard: { mode: 'side', corner: 'left', lane: false }, deskMin: 990, snake: 14,
    ringScale: 3.5, ringAlpha: 0.7, ringMs: 1100, bump: true
  };
  var RM = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  /* ================= the approved engine (demo version 13), drawing on one fixed layer over the window ================= */
  var MxFly = (function () {
    var RAMP = ' .:-=+*#%@';
    var cv, ctx, dpr = 1, busy = 0, W = 0, H = 0, frames = 0;
    function rnd(a) { return a.charAt((Math.random() * a.length) | 0); }
    function cl(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function rel(r) { return { left: r.left, top: r.top, right: r.right, bottom: r.bottom, width: r.width, height: r.height }; }
    function center(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
    function make() {
      cv = document.createElement('canvas');
      cv.className = 'mx-fly-layer';
      cv.setAttribute('aria-hidden', 'true');
      cv.style.cssText = 'position:fixed;left:0;top:0;pointer-events:none;z-index:2147483000;';
      document.body.appendChild(cv);
      ctx = cv.getContext('2d');
      W = document.documentElement.clientWidth || innerWidth; H = innerHeight; dpr = Math.min(1.5, window.devicePixelRatio || 1);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function drop() { if (cv && cv.parentNode) cv.parentNode.removeChild(cv); cv = ctx = null; }

    /* ---------- the route: where the plusses go ---------- */
    function plan(o){
      var s = Math.max(4, o.spacing), R = rel(o.src.getBoundingClientRect()), to = center(o.target);
      var A = o.area, C = o.clip, m = o.margin == null ? 3 : o.margin, T = o.turn == null ? 6 : o.turn;
      var vT = Math.max(R.top, C.top), vB = Math.min(R.bottom, C.bottom);
      if (vB - vT < s * 2) return null;
      /* mode "auto": the top of the photo when you can see it, otherwise its bottom corner */
      var mode = o.mode, corner = o.corner || "near";
      if (mode === "auto"){ if (R.top - s >= C.top + s * 0.5){ mode = o.topMode || "up"; corner = o.topCorner || corner; } else { mode = o.scrollMode || "side"; corner = o.scrollCorner || corner; } }
      mode = mode === "side" || mode === "under" ? mode : "up";
      var toward = R.left + R.width / 2 <= to.x ? 1 : -1, dir = toward;
      if (mode === "side") dir = corner === "left" ? -1 : corner === "right" ? 1 : toward;
    if (mode === "under") dir = 1;
      /* columns sit on the icon; rows too, unless a lane (the gap between the path line and the title) is given:
         then the rows shift so one of them runs right through that gap */
      var oy = to.y, lane = null;
      if (mode === "side" && o.lane != null && o.lane > C.top + s && o.lane < vB - s){ lane = o.lane; oy = to.y + ((((lane - to.y) % s) + s) % s); }
      var i0 = Math.ceil((A.left + s / 2 - to.x) / s), i1 = Math.floor((A.right - s / 2 - to.x) / s);
      var j0 = Math.ceil((A.top + s / 2 - oy) / s), j1 = Math.floor((A.bottom - s / 2 - oy) / s);
      var nI = i1 - i0 + 1, nJ = j1 - j0 + 1;
      if (nI < 2 || nJ < 2) return null;
      var blk = new Uint8Array(nI * nJ);
      function ix(i, j){ return (j - j0) * nI + (i - i0); }
      function inG(i, j){ return i >= i0 && i <= i1 && j >= j0 && j <= j1; }
      function mark(r, mm, v){
        var a = Math.ceil((r.left - mm - to.x) / s), b = Math.floor((r.right + mm - to.x) / s), c = Math.ceil((r.top - mm - oy) / s), d = Math.floor((r.bottom + mm - oy) / s);
        for (var j = Math.max(c, j0); j <= Math.min(d, j1); j++) for (var i = Math.max(a, i0); i <= Math.min(b, i1); i++) blk[ix(i, j)] = v;
      }
      (o.obstacles || []).forEach(function (r){ mark(r, m, 1); });
      var col = [], line, i, j, sdir;
      if (mode === "up"){
        /* a row just above the photo, or the first row under the header when the photo top is scrolled away */
        var jb = Math.floor((R.top - s - oy) / s), jMin = Math.ceil((C.top + s * 0.5 - oy) / s);
        if (jb < jMin) jb = jMin;
        line = oy + jb * s;
        var iA = Math.ceil((R.left + s / 2 - to.x) / s), iB = Math.floor((R.right - s / 2 - to.x) / s);
        var iFar = dir > 0 ? iA : iB, iNear = dir > 0 ? iB : iA;
        for (i = iFar; dir > 0 ? i <= iNear : i >= iNear; i += dir) col.push({ i: i, j: jb });
        sdir = dir > 0 ? 0 : 1;
        mark({ left: R.left, right: R.right, top: Math.max(vT, line + s * 0.5), bottom: vB }, 0, 1);
      } else if (mode === "under"){
        /* phones: from the photo's bottom left corner a short step down, then one row under the photo across to the
           right of the page; from there the line climbs up into the icon */
        /* the row ends at the right of the page; when the icon sits further in (the wishlist) the line climbs
           the right side and then runs over to the icon */
        var iR = Math.max(0, Math.floor((A.right - s * 1.5 - to.x) / s)); if (iR < 3) iR = 0;
        var iL = Math.min(0, Math.ceil((R.left + s * 0.5 - to.x) / s)), jIn = Math.floor((R.bottom - s * 0.5 - oy) / s), jr = -1, jEnd = Math.ceil((R.bottom + s * 3.5 - oy) / s);
        for (j = Math.ceil((R.bottom + s * 0.5 - oy) / s); j <= Math.min(j1, jEnd) && oy + j * s <= C.bottom - s * 0.5 && jr < 0; j++){
          var rowOk = true;
          for (i = iL; i <= iR && rowOk; i++) if (!inG(i, j) || blk[ix(i, j)]) rowOk = false;
          var ry = oy + j * s, rx0 = to.x + iL * s - s * 0.5, rx1 = to.x + iR * s + s * 0.5;
          (o.obstacles || []).concat(o.rowAvoid || []).forEach(function (r){ if (r.bottom > ry - s * 0.6 && r.top < ry + s * 0.6 && r.right > rx0 && r.left < rx1) rowOk = false; });
          for (var jd = jIn + 1; jd < j && rowOk; jd++) if (!inG(iL, jd) || blk[ix(iL, jd)]) rowOk = false;
          if (rowOk) jr = j;
        }
        /* (the row keeps more than half a step away from anything under the photo)
           no free row right under the photo (its bottom is off screen): the bottom left corner climb */
        if (jr < 0) return plan(Object.assign({}, o, { mode: "side", corner: "left" }));
        if (oy + jIn * s < vT + s * 0.5) jIn = jr - 1;
        line = oy + jr * s;
        for (j = jIn; j < jr; j++) col.push({ i: iL, j: j });
        var nDown = col.length;
        for (i = iL; i <= iR; i++) col.push({ i: i, j: jr });
        sdir = 0;
      } else {
        /* a column on the photo's edge, from its bottom corner up (to the lane when there is one) */
        var ic = dir > 0 ? Math.floor((R.right - s * 0.5 - to.x) / s) : Math.ceil((R.left + s * 0.5 - to.x) / s);
        var jBot = Math.floor((vB - s * 0.5 - oy) / s), jTop = lane != null ? Math.round((lane - oy) / s) : Math.ceil((vT + s * 0.5 - oy) / s);
        line = to.x + ic * s;
        for (j = jBot; j >= jTop; j--) col.push({ i: ic, j: j });
        sdir = 3;
        mark(dir > 0 ? { left: R.left, right: line - s * 0.5, top: vT, bottom: vB } : { left: line + s * 0.5, right: R.right, top: vT, bottom: vB }, 0, 1);
      }
      col = col.filter(function (c){ return inG(c.i, c.j); });
      if (!col.length) return null;
      var start = col[col.length - 1];
      col.forEach(function (c, k){ blk[ix(c.i, c.j)] = k === col.length - 1 ? 0 : 1; });
      var gj = Math.max(j0, Math.min(j1, Math.ceil((to.y + s * 1.5 - oy) / s))), goal = { i: 0, j: gj };
      if (!inG(0, gj)) return null;
      blk[ix(0, gj)] = 0;
      var nearA = new Float32Array(nI * nJ);
      for (j = j0; j <= j1; j++) for (i = i0; i <= i1; i++){
        var n = 0;
        if (i > i0 && blk[ix(i - 1, j)]) n++; if (i < i1 && blk[ix(i + 1, j)]) n++;
        if (j > j0 && blk[ix(i, j - 1)]) n++; if (j < j1 && blk[ix(i, j + 1)]) n++;
        nearA[ix(i, j)] = n * 0.4;
      }
      /* with a lane, the strip between the header and the lane is off limits, except the icon's own column;
         the lane itself is the way to go, so running close to the texts there costs nothing extra */
      if (lane != null){
        var jl = Math.round((lane - oy) / s);
        for (j = Math.ceil((C.top - oy) / s); j < jl; j++) for (i = i0; i <= i1; i++) if (i !== 0 && inG(i, j)) blk[ix(i, j)] = 1;
        for (i = i0; i <= i1; i++) if (inG(i, jl)) nearA[ix(i, jl)] = 0;
      }
      var DX = [1, -1, 0, 0], DY = [0, 0, 1, -1];
      function astar(needUp){
        var N = nI * nJ * 4, g = new Float32Array(N), from = new Int32Array(N), done = new Uint8Array(N), heap = [];
        g.fill(Infinity); from.fill(-1);
        function hh(i, j){ return Math.abs(i - goal.i) + Math.abs(j - goal.j); }
        function push(f, k){ heap.push([f, k]); var c = heap.length - 1; while (c > 0){ var p = (c - 1) >> 1; if (heap[p][0] <= heap[c][0]) break; var t = heap[p]; heap[p] = heap[c]; heap[c] = t; c = p; } }
        function pop(){ var top = heap[0], last = heap.pop(); if (heap.length){ heap[0] = last; var c = 0; for (;;){ var l = c * 2 + 1, r = l + 1, b = c; if (l < heap.length && heap[l][0] < heap[b][0]) b = l; if (r < heap.length && heap[r][0] < heap[b][0]) b = r; if (b === c) break; var t = heap[b]; heap[b] = heap[c]; heap[c] = t; c = b; } } return top; }
        var sk = ix(start.i, start.j) * 4 + sdir, gk = ix(goal.i, goal.j), steps = 0;
        g[sk] = 0; push(hh(start.i, start.j), sk);
        while (heap.length && steps++ < 300000){
          var k = pop()[1]; if (done[k]) continue; done[k] = 1;
          var c = k >> 2, d = k & 3, ci = c % nI + i0, cj = ((c / nI) | 0) + j0;
          if (c === gk && (!needUp || d === 3)){
            var out = [], q = k;
            while (q !== sk && q >= 0){ var cc = q >> 2; out.push({ i: cc % nI + i0, j: ((cc / nI) | 0) + j0 }); q = from[q]; }
            return out.reverse();
          }
          for (var nd = 0; nd < 4; nd++){
            if (nd === (d ^ 1)) continue;
            var ni = ci + DX[nd], nj = cj + DY[nd];
            if (!inG(ni, nj)) continue;
            var nc = ix(ni, nj);
            if (blk[nc] && nc !== gk) continue;
            var cost = g[k] + 1 + (nd !== d ? T : 0) + nearA[nc] + (mode === "up" && nj > goal.j ? 0.02 * (nj - goal.j) : 0), nk = nc * 4 + nd;
            if (cost < g[nk]){ g[nk] = cost; from[nk] = k; push(cost + hh(ni, nj), nk); }
          }
        }
        return null;
      }
      var route = null;
    if (mode === "under"){
      /* phones: straight up the right side, then (for an icon further in) across just under it and up into it */
      var fx = [], fi = start.i, fj = start.j, okF = true, jt = goal.i === fi ? goal.j : goal.j + 1;
      while (fj > jt){ fj--; fx.push({ i: fi, j: fj }); }
      while (fi > goal.i){ fi--; fx.push({ i: fi, j: fj }); }
      while (fj > goal.j){ fj--; fx.push({ i: fi, j: fj }); }
      fx.forEach(function (c){ if (!inG(c.i, c.j) || (blk[ix(c.i, c.j)] && !(c.i === goal.i && c.j === goal.j))) okF = false; });
      if (okF && fx.length) route = fx;
    }
    route = route || astar(true) || astar(false);
    var free = !!route;
      if (!route){
        /* no free way: the old corner route (straight across, then up) */
        route = [];
        var ci2 = start.i, cj2 = start.j;
        while (ci2 !== 0){ ci2 += ci2 < 0 ? 1 : -1; route.push({ i: ci2, j: cj2 }); }
        while (cj2 !== goal.j){ cj2 += cj2 < goal.j ? 1 : -1; route.push({ i: ci2, j: cj2 }); }
      }
      /* top of the photo: when the route runs along and then climbs, the whole line moves up to that row (one clean line, no step) */
      if (mode === "up" && free){
        var h = 0; while (h < route.length && route[h].j === start.j) h++;
        var vx = h ? route[h - 1].i : start.i, uu = 0;
        while (h + uu < route.length && route[h + uu].i === vx && route[h + uu].j === start.j - uu - 1) uu++;
        for (var u = uu; u > 0; u--){
          var jr = start.j - u, ok = true, q2;
          for (q2 = 0; q2 < col.length && ok; q2++) if (!inG(col[q2].i, jr) || blk[ix(col[q2].i, jr)]) ok = false;
          for (q2 = 0; q2 < h && ok; q2++) if (blk[ix(route[q2].i, jr)]) ok = false;
          if (!ok) continue;
          col = col.map(function (c){ return { i: c.i, j: jr }; });
          route = route.slice(0, h).map(function (c){ return { i: c.i, j: jr }; }).concat(route.slice(h + u));
          line = oy + jr * s;
          break;
        }
      }
      return { mode: mode, dir: dir, s: s, to: to, oy: oy, R: R, vT: vT, vB: vB, line: line, col: col, route: route, free: free, lane: lane, nDown: nDown || 0,
        xy: function (c){ return { x: to.x + c.i * s, y: oy + c.j * s }; } };
    }

    /* ---------- the photo as a grid of glyphs (only the part you can see); the 300px copy is cropped like the photo ---------- */
    function sample(pix, el, cell, pl, clip) {
      var R = pl.R, cols = Math.max(4, Math.floor(R.width / cell)), rows = Math.max(4, Math.floor(R.height / cell));
      var t = document.createElement('canvas'); t.width = cols; t.height = rows;
      var c = t.getContext('2d'), iw = pix.naturalWidth || pix.width, ih = pix.naturalHeight || pix.height;
      var fit = getComputedStyle(el).objectFit || 'fill';
      c.fillStyle = '#fff'; c.fillRect(0, 0, cols, rows);
      if ((fit === 'cover' || fit === 'contain') && iw && ih) {
        var s = fit === 'cover' ? Math.max(R.width / iw, R.height / ih) : Math.min(R.width / iw, R.height / ih),
            dw = iw * s, dh = ih * s, kx = cols / R.width, ky = rows / R.height;
        c.drawImage(pix, ((R.width - dw) / 2) * kx, ((R.height - dh) / 2) * ky, dw * kx, dh * ky);
      } else c.drawImage(pix, 0, 0, cols, rows);
      var d = c.getImageData(0, 0, cols, rows).data, out = [];
      for (var y = 0; y < rows; y++) for (var x = 0; x < cols; x++) {
        var i = (y * cols + x) * 4, dark = 1 - (d[i] * 0.3 + d[i + 1] * 0.59 + d[i + 2] * 0.11) / 255;
        if (dark < 0.12) continue;
        var px = R.left + x * cell + cell / 2, py = R.top + y * cell + cell / 2;
        if (py < clip.top + cell / 2 || py > clip.bottom - cell / 2 || px < 0 || px > W) continue;
        if (pl.mode === 'up' && py < pl.line + cell) continue;
        if (pl.mode === "side" && (pl.dir > 0 ? px > pl.line - cell : px < pl.line + cell)) continue;
      if (pl.mode === "under" && (py > pl.line - cell || (px < pl.xy(pl.col[0]).x + cell && py > pl.xy(pl.col[0]).y - cell))) continue;
        out.push({ x: px, y: py, gx: x, gy: y, dark: dark, ch: RAMP.charAt(Math.min(RAMP.length - 1, Math.round(dark * (RAMP.length - 1)))) });
      }
      return { list: out, cols: cols, rows: rows };
    }

    function glyph(ch, x, y, a) { if (a <= 0.01) return; ctx.globalAlpha = cl(a); ctx.fillText(ch, x, y); }
    function ink(p) { return 0.35 + 0.65 * p.dark; }

    function run(o){
      if (busy && !o.force) return;
      var reduce = o.respectReduced !== false && !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
      if (reduce){ o.arrive && o.arrive(); o.done && o.done(); return; }
      var pl = plan(o);
      if (!pl){ o.arrive && o.arrive(); o.done && o.done(); return; }
      busy = 1; make();
      var cell = o.cell, g = sample(o.pix, o.src, cell, pl, o.clip), P = g.list, R = pl.R, s = pl.s, dir = pl.dir,
          glyphs = o.glyphs || "01アイウエオカキクケコｱｲｳ#$%&", trip = o.trip || "+", hold = o.hold, dur = o.duration, t0 = performance.now();
      o.src.style.opacity = "0";
      var font = cell + "px 'Roboto Mono', monospace", tFont = (o.plusWeight || 300) + " " + (o.plusSize || 11) + "px 'Roboto Mono', monospace";
      var path = pl.col.map(function (c){ var q = pl.xy(c); return { x: q.x, y: q.y, over: true, lit: 9 }; });
      var nCol = path.length, climb = 0.16, span = Math.max(1, pl.vB - pl.vT), arrived = 0;
      pl.route.forEach(function (c){ var q = pl.xy(c); path.push({ x: q.x, y: q.y, over: false, lit: 9 }); });
      P.forEach(function (p){
        p.seed = Math.random(); p.rc = rnd(glyphs);
        var k;
        if (pl.mode === "up"){
          var cf = (p.x - R.left) / R.width; if (dir < 0) cf = 1 - cf;
          p.st = cl(cf) * 0.32 + (p.gy / g.rows) * 0.06 + p.seed * 0.02;
          k = Math.round((p.x - pl.to.x) / s) - pl.col[0].i; k = dir > 0 ? k : -k;
          p.D = p.y - pl.line;
        } else if (pl.mode === "under"){
          /* each column of ASCII drops into the row under the photo, the column on the left first */
          p.st = cl((p.x - R.left) / R.width) * 0.32 + (1 - p.gy / g.rows) * 0.06 + p.seed * 0.02;
          k = pl.nDown + Math.round((p.x - pl.to.x) / s) - pl.col[pl.nDown].i;
          k = Math.max(pl.nDown, Math.min(nCol - 1, k));
          p.D = pl.line - p.y;
        } else {
          var rf = (pl.vB - p.y) / span;
          p.st = cl(rf) * 0.32 + (1 - Math.abs(pl.line - p.x) / R.width) * 0.06 + p.seed * 0.02;
          k = pl.col[0].j - Math.round((p.y - pl.oy) / s);
          p.D = Math.abs(pl.line - p.x);
        }
        p.ta = p.st + climb;
        if (k >= 0 && k < nCol && p.ta < path[k].lit) path[k].lit = p.ta;
      });
      var q;
      if (pl.mode === "up"){
        /* the line starts at the first column that really has ASCII and never runs backwards */
        while (nCol > 1 && path[0].lit >= 9){ path.shift(); nCol--; }
        for (q = 0; q < nCol; q++){
          if (q > 0) path[q].lit = Math.max(path[q].lit >= 9 ? path[q - 1].lit : path[q].lit, path[q - 1].lit + 0.004);
          else if (path[q].lit >= 9) path[q].lit = 0.25;
        }
      } else {
        /* the line starts in the corner straight away and climbs as the rows slide in */
        for (q = 0; q < nCol; q++){
          if (q === 0){ if (path[q].lit >= 9) path[q].lit = 0; }
          else path[q].lit = Math.max(path[q].lit >= 9 ? path[q - 1].lit + 0.004 : path[q].lit, path[q - 1].lit + 0.004);
        }
      }
      var tOver = nCol ? path[nCol - 1].lit : 0, nGrow = path.length - nCol, growDur = 0.22, tArrive = tOver + growDur, fade0 = tArrive + 0.03, fadeDur = Math.max(0.1, 0.97 - fade0);
    /* snake (like the old Nokia game): a body of a set number of plusses; the tail follows the head along the
       same path and disappears where the head was that many steps ago; after the head reaches the icon the rest
       of the body runs into it. Snake length 0 = the whole line stays and fades out from the start. */
    var L = Math.max(0, Math.round(o.snake || 0)), N = path.length, step = Math.max(0.002, Math.min(nGrow ? growDur / nGrow : 0.01, (0.985 - tArrive) / Math.max(1, L)));
      for (q = nCol; q < path.length; q++) path[q].lit = tOver + (q - nCol + 1) / Math.max(1, nGrow) * growDur;
    for (q = 0; q < N; q++) path[q].off = !L ? fade0 + q / N * fadeDur : q + L < N ? path[q + L].lit : tArrive + (q + L - N + 1) * step;
      function flick(p, chance){ if (Math.random() < chance) p.rc = rnd(glyphs); return p.rc; }
      function waiting(p, t){
        if (t < hold) return Math.random() < t / hold ? (Math.random() < 0.4 ? rnd(glyphs) : p.ch) : p.ch;
        return Math.random() < 0.15 ? rnd(glyphs) : p.ch;
      }
      frames = 0;
      function frame(now){
        if (!ctx) return;
        frames++;
        var t = Math.min(1, (now - t0) / dur), u = t < hold ? 0 : (t - hold) / (1 - hold), i, p;
        ctx.clearRect(0, 0, W, H);
        ctx.font = font; ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillStyle = "#000";
        if (t < hold){
          for (i = 0; i < P.length; i++){ p = P[i]; glyph(waiting(p, t), p.x, p.y, ink(p)); }
        } else {
          for (i = 0; i < P.length; i++){ p = P[i];
            if (u < p.st){ glyph(waiting(p, t), p.x, p.y, ink(p)); continue; }
            if (u >= p.ta) continue;
            var k = (u - p.st) / climb, dist = Math.floor(k * p.D / cell) * cell;
            for (var tr = 0; tr < 3; tr++){ var dd = dist - tr * cell; if (dd < 0) break;
              var ch = tr ? rnd(glyphs) : flick(p, 0.5), a = ink(p) * [1, 0.4, 0.15][tr];
              if (pl.mode === "up") glyph(ch, p.x, p.y - dd, a); else if (pl.mode === "under") glyph(ch, p.x, p.y + dd, a); else glyph(ch, p.x + dir * dd, p.y, a); }
          }
          ctx.font = tFont;
          var lead = -1;
          for (var c = 0; c < path.length; c++){ var pt = path[c];
            if (u < pt.lit){ if (lead < 0 && c > 0 && u >= path[c - 1].lit && !arrived) lead = c; continue; }
            glyph(trip, pt.x, pt.y, 0.9 * (1 - cl((u - pt.off) / (L ? 0.015 : 0.06))));
          }
          if (lead >= 0) glyph(trip, path[lead].x, path[lead].y, (Math.floor(now / 90) % 2) ? 0.9 : 0.25);
          if (u >= tArrive && !arrived){ arrived = 1; o.arrive && o.arrive(); }
        }
        ctx.globalAlpha = 1;
        if (t < 1) tick(frame);
        else { drop(); busy = 0; o.src.style.opacity = ""; if (!arrived){ arrived = 1; o.arrive && o.arrive(); } o.done && o.done(); }
      }
      tick(frame);
    }

    /* next frame: requestAnimationFrame, with a timer fallback for views that pause it */
    function tick(fn) {
      var done = 0;
      function go() { if (done) return; done = 1; fn(performance.now()); }
      try { requestAnimationFrame(go); } catch (x) {}
      setTimeout(go, 40);
    }
    return { run: run, plan: plan, busy: function () { return !!busy; } };
  })();

  /* ================= styles: dot, ping ring, bump, header shown during the effect ================= */
  var styled = 0;
  function style() {
    if (styled) return; styled = 1;
    var s = document.createElement('style');
    s.textContent =
      '.mx-fly-host{position:relative}' +
      '.mx-fly-dot{position:absolute!important;top:-2px!important;right:-3px!important;bottom:auto!important;left:auto!important;width:5px!important;height:5px!important;min-width:0!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;border-radius:50%!important;background:currentColor!important;pointer-events:none;opacity:0;transform:scale(0);transition:opacity .3s ease,transform .25s cubic-bezier(.2,.8,.2,1.4)}' +
      '.mx-fly-dot.is-on{opacity:1;transform:scale(1)}' +
      '.mx-fly-ping .mx-wish__dot::after,.mx-fly-ping .mx-fly-dot::after{content:"";position:absolute;inset:0;border-radius:50%;border:1px solid currentColor;opacity:0;animation:mxFlyPing var(--mx-ring-ms,1100ms) cubic-bezier(.2,.8,.2,1) 1}' +
      '@keyframes mxFlyPing{0%{opacity:var(--mx-ring-a,.7);transform:scale(1)}100%{opacity:0;transform:scale(var(--mx-ring-s,3.5))}}' +
      '.mx-fly-bump svg{animation:mxFlyBump .42s cubic-bezier(.2,.8,.2,1)}' +
      '@keyframes mxFlyBump{0%{transform:scale(1)}35%{transform:scale(1.22)}70%{transform:scale(.94)}100%{transform:scale(1)}}' +
      '.mxh.mx-fly-show,.mxh.mx-fly-show.is-home-top,.mxh.mx-fly-show.is-home-float{visibility:visible!important;opacity:1!important;transform:none!important;transition:opacity .3s ease,transform .4s cubic-bezier(.2,.7,.2,1)!important}';
    document.head.appendChild(s);
  }

  /* Roboto Mono Light for the plusses (the store loads the regular weight only) */
  var fontP = null;
  function fonts() {
    if (fontP) return fontP;
    try {
      var l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = 'https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@300;400&display=swap';
      document.head.appendChild(l);
    } catch (e) {}
    var load = document.fonts && document.fonts.load ? Promise.all([
      document.fonts.load("300 11px 'Roboto Mono'"), document.fonts.load("400 7px 'Roboto Mono'")
    ]) : Promise.resolve();
    fontP = Promise.race([load.catch(function () {}), new Promise(function (r) { setTimeout(r, 700); })]);
    return fontP;
  }

  /* ================= what is on screen ================= */
  function vw() { return document.documentElement.clientWidth || innerWidth; }
  function visible(el) {
    if (!el || !el.getClientRects().length) return false;
    if (el.checkVisibility) return el.checkVisibility({ opacityProperty: true, visibilityProperty: true });
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return false;
    }
    return true;
  }
  function shown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height || r.bottom <= 0 || r.top >= innerHeight || r.right <= 0 || r.left >= vw()) return false;
    return visible(el);
  }
  function inArea(r) { return r.width >= 1 && r.height >= 1 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < vw(); }
  /* the bottom of the header you can see: the plusses and the ASCII stay below it, except the last run into the icon */
  function headerBottom() {
    var b = 0;
    ['.mxh .mxh-glass', '.mxh', '.section-header .header-wrapper', '.mx-fixed-icons.is-on'].forEach(function (q) {
      var el = document.querySelector(q);
      if (el && shown(el)) { var r = el.getBoundingClientRect(); if (r.top < 140 && r.bottom > b) b = r.bottom; }
    });
    return b;
  }
  /* every line of text, button, icon and photo on screen is something the plusses go around */
  function obstacles(skip) {
    var out = [], cache = new Map(), rg = document.createRange();
    function skipped(el) { for (var i = 0; i < skip.length; i++) if (skip[i] && (skip[i] === el || skip[i].contains(el))) return true; return false; }
    function ok(el) {
      if (cache.has(el)) return cache.get(el);
      var v = !skipped(el) && inArea(el.getBoundingClientRect()) && visible(el);
      cache.set(el, v); return v;
    }
    var tw = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentElement;
        if (!p || /^(SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/.test(p.tagName)) return NodeFilter.FILTER_REJECT;
        return n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    }), n;
    while ((n = tw.nextNode())) {
      if (!ok(n.parentElement)) continue;
      rg.selectNodeContents(n);
      Array.prototype.forEach.call(rg.getClientRects(), function (r) { if (inArea(r)) out.push(r); });
    }
    document.querySelectorAll('img, svg, video, canvas, button, input, select, textarea, [role="button"]').forEach(function (el) {
      if (el.closest('svg') && el.tagName.toLowerCase() !== 'svg') return;
      if (el.classList && el.classList.contains('mx-fly-layer')) return;
      if (!ok(el)) return;
      out.push(el.getBoundingClientRect());
    });
    return out;
  }
  /* phones, product page: painted shapes right under the photo (slide dots or bars); the row under the photo keeps clear
     of them */
  function shapes(img) {
    var view = img.closest('[data-mxp-view]'), out = [], b = img.getBoundingClientRect().bottom;
    if (!view) return out;
    view.querySelectorAll('*').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < b - 1 || r.top > b + CFG.spacing * 5 || r.width < 1 || r.height < 1 || r.height > 40 || !visible(el)) return;
      var cs = getComputedStyle(el), bg = cs.backgroundColor;
      if ((bg && bg !== 'transparent' && !/rgba\([^)]*,\s*0\)$/.test(bg)) || parseFloat(cs.borderTopWidth) > 0 || parseFloat(cs.borderBottomWidth) > 0) out.push(r);
    });
    return out;
  }
  /* product page, desktop: the gap between the path line and the product title */
  function lane(top) {
    var view = document.querySelector('[data-mxp-view]');
    if (!view) return null;
    var a = view.querySelector('.pp-info > .pp-path') || view.querySelector('.pp-path'), b = view.querySelector('.pp-info .pp-title') || view.querySelector('.pp-title');
    if (!shown(a) || !shown(b)) return null;
    var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
    if (rb.top <= ra.bottom || ra.bottom < top) return null;
    return (ra.bottom + rb.top) / 2;
  }

  /* ================= icons ================= */
  function candidates(kind) {
    if (kind === 'wish') return [].slice.call(document.querySelectorAll('[data-mx-wishlist-icon]'));
    return [document.querySelector('.mxh [data-mx-cart]'), document.querySelector('.mx-fixed-icons.is-on .header__icon--cart'), document.getElementById('cart-icon-bubble')].filter(Boolean);
  }
  /* the visible icon; if the header is hidden, the glass header slides in for the effect */
  function target(kind) {
    var list = candidates(kind), i;
    for (i = 0; i < list.length; i++) if (shown(list[i])) return { el: list[i], bar: null };
    var glass = null;
    for (i = 0; i < list.length; i++) if (list[i].closest('.mxh')) { glass = list[i]; break; }
    if (!glass) return null;
    var bar = glass.closest('.mxh');
    style(); bar.classList.add('mx-fly-show');
    return { el: glass, bar: bar, wait: 420 };
  }
  function dotOf(icon, kind) {
    if (kind === 'wish') return icon.querySelector('.mx-wish__dot');
    var d = icon.querySelector('.mx-fly-dot');
    if (!d) {
      d = document.createElement('span'); d.className = 'mx-fly-dot'; d.setAttribute('aria-hidden', 'true');
      if (getComputedStyle(icon).position === 'static') icon.classList.add('mx-fly-host');
      icon.appendChild(d);
    }
    return d;
  }
  /* the dot pings once; the cart dot only shows for the ping */
  function ping(icon, kind, calm) {
    style();
    var d = dotOf(icon, kind);
    if (!d) return;
    icon.style.setProperty('--mx-ring-s', CFG.ringScale);
    icon.style.setProperty('--mx-ring-a', CFG.ringAlpha);
    icon.style.setProperty('--mx-ring-ms', CFG.ringMs + 'ms');
    if (kind === 'cart') { void d.offsetWidth; d.classList.add('is-on'); }
    icon.classList.remove('mx-fly-ping', 'mx-fly-bump'); void icon.offsetWidth;
    icon.classList.add('mx-fly-ping');
    if (CFG.bump && !calm) icon.classList.add('mx-fly-bump');
    clearTimeout(icon._mxFly);
    icon._mxFly = setTimeout(function () {
      icon.classList.remove('mx-fly-ping', 'mx-fly-bump');
      if (kind === 'cart' && d.parentNode) { d.classList.remove('is-on'); setTimeout(function () { if (!d.classList.contains('is-on') && d.parentNode) d.parentNode.removeChild(d); }, 320); }
    }, CFG.ringMs + 80);
  }

  /* ================= the photo that was used ================= */
  var tap = { el: null, t: 0 };
  function remember(e) { tap = { el: e.target, t: Date.now() }; }
  document.addEventListener('pointerdown', remember, true);
  document.addEventListener('click', remember, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') remember(e); }, true);

  function seen(img) {
    if (!img) return 0;
    var r = img.getBoundingClientRect();
    if (r.width < 20 || r.height < 20 || r.right <= 0 || r.left >= vw()) return 0;
    return Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
  }
  /* product page: the photo you see most of */
  function productPhoto() {
    var view = document.querySelector('[data-mxp-view]');
    if (!view) return null;
    var best = null, most = 70;
    view.querySelectorAll('.pp-stack .pp-slide img, .pp-slide img').forEach(function (img) { var v = seen(img); if (v > most) { most = v; best = img; } });
    return best;
  }
  function photo() {
    var el = tap.el && Date.now() - tap.t < 8000 && tap.el.closest ? tap.el : null, img = null, box;
    if (el) {
      if (el.closest('[data-mxp-view]')) img = productPhoto();
      else if ((box = el.closest('article.c-row'))) img = box.querySelector('.wl-photo img');
      else if ((box = el.closest('.mx-card__media, a.mx-card, .mx-card, .card-wrapper, .card, product-info, .product'))) img = box.querySelector('img');
    }
    if (!img) img = productPhoto();
    return seen(img) > 20 ? img : null;
  }
  /* a 300px copy of the photo that the layer is allowed to read */
  function copy(img) {
    return new Promise(function (ok, no) {
      var src = img.currentSrc || img.src;
      if (!src) return no();
      try { var u = new URL(src, location.href); u.searchParams.set('width', '300'); src = u.href; } catch (e) {}
      var p = new Image();
      p.crossOrigin = 'anonymous'; p.decoding = 'async';
      var t = setTimeout(no, 2500);
      p.onload = function () { clearTimeout(t); ok(p); };
      p.onerror = function () { clearTimeout(t); no(); };
      p.src = src;
    });
  }

  /* ================= play ================= */
  function play(kind, after) {
    var finish = function () { if (after) { var a = after; after = null; a(); } };
    var calm = RM.matches;
    var img = calm ? null : photo();
    var tg = target(kind);
    if (!tg) return finish();
    var hide = function () { if (tg.bar) { var b = tg.bar; setTimeout(function () { b.classList.remove('mx-fly-show'); }, 300); } };
    if (calm || !img || MxFly.busy()) { ping(tg.el, kind, calm); hide(); return finish(); }
    Promise.all([copy(img), fonts(), new Promise(function (r) { setTimeout(r, tg.wait || 0); })]).then(function (out) {
      var desk = vw() >= CFG.deskMin, pdp = !!img.closest('[data-mxp-view]'), m = desk ? CFG.desk : pdp ? CFG.phone : CFG.phoneCard, top = headerBottom();
      var area = { left: 0, top: 0, right: vw(), bottom: innerHeight };
      var o = {
        pix: out[0], src: img, target: tg.el, area: area, clip: { left: 0, right: area.right, top: top, bottom: area.bottom },
        obstacles: obstacles([tg.el, img]), rowAvoid: !desk && pdp ? shapes(img) : null, mode: m.mode, corner: m.corner, lane: m.lane ? lane(top) : null,
        margin: CFG.margin, turn: CFG.turn, spacing: CFG.spacing, respectReduced: false,
        duration: CFG.duration, hold: CFG.hold, cell: CFG.cell, glyphs: CFG.glyphs, trip: CFG.trip, plusWeight: CFG.plusWeight, plusSize: CFG.plusSize, snake: CFG.snake,
        arrive: function () { ping(tg.el, kind, false); },
        done: function () { hide(); finish(); }
      };
      try { MxFly.run(o); } catch (e) { ping(tg.el, kind, false); hide(); finish(); }
    }, function () { ping(tg.el, kind, false); hide(); finish(); });
  }

  /* ================= wishlist: after a confirmed save ================= */
  document.addEventListener('mx:wishlist', function (e) {
    var d = e.detail || {};
    if (d.saved === true && d.handle) play('wish');
  });

  /* ================= cart: after Shopify accepts the add, with the drawer closed ================= */
  function drawerOpen() { var d = document.querySelector('cart-drawer'); return !!(d && d.classList.contains('active')); }
  var hold = { on: 0, queue: [], timer: 0 };
  function release() {
    hold.on = 0; clearTimeout(hold.timer);
    var q = hold.queue; hold.queue = [];
    q.forEach(function (c) { try { c.fn.apply(c.self, c.args); } catch (e) {} });
  }
  /* the drawer opens straight after the effect, never during it */
  function wrapDrawer() {
    var C = window.customElements && customElements.get('cart-drawer');
    if (!C || C.prototype.__mxFly) return;
    var open = C.prototype.open;
    C.prototype.open = function () {
      if (hold.on) { hold.queue.push({ fn: open, self: this, args: arguments }); return; }
      return open.apply(this, arguments);
    };
    C.prototype.__mxFly = true;
  }
  if (window.customElements) customElements.whenDefined('cart-drawer').then(wrapDrawer);

  function isAdd(input) {
    var u = typeof input === 'string' ? input : input && input.url ? input.url : '';
    return /\/cart\/add(\.js)?(\?|$)/.test(u);
  }
  if (window.fetch && !window.fetch.__mxFly) {
    var base = window.fetch;
    var wrapped = function (input) {
      var watch = false;
      try { watch = isAdd(input) && !drawerOpen(); } catch (e) {}
      var p = base.apply(this, arguments);
      if (!watch) return p;
      return p.then(function (res) {
        if (res && res.ok && !drawerOpen()) {
          wrapDrawer();
          hold.on = 1; clearTimeout(hold.timer);
          hold.timer = setTimeout(release, CFG.duration + 4000);
          play('cart', release);
        }
        return res;
      });
    };
    wrapped.__mxFly = true;
    window.fetch = wrapped;
  }
})();
